// Conversion trackers
/* global fbq */
/* global gtag_report_conversion */

const runAlert = function () {
  alert('If you are using Opera Mini,please disable Data Savings Mode.');
};

const isOperaMini = (navigator.userAgent.indexOf('Opera Mini') > -1);
if (isOperaMini) {
  runAlert();
} else {
  const isOperaMini_alt = Object.prototype.toString.call(window.operamini) === '[object OperaMini]';
  if (isOperaMini_alt) {
    runAlert();
  }
}

function validateEmail(email) {
  const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(String(email).toLowerCase());
}

document.addEventListener('DOMContentLoaded', () => {
  $('select').addClass('form-select').removeClass('form-control'); //bs5 switchover.

  const availableLangs = $('#user_lang option').map(function () {
    return $(this).val();
  }).toArray();

  $('#user_phone').intlTelInput({ nationalMode: false, allowDropdown: false, utilsScript: '/utils2.js' });

  $('#user_country').change(() => {
    const userCountry = $('#user_country').val();
    const dists = {
      'MZ': ['Ancuabe District', 'Balama District','Chiúre District','Ibo District','Macomia District','Mecúfi District',	'Meluco District'	,'Mocímboa da Praia District',	'Montepuez District'	,'Mueda District',	'Muidumbe District'	,'Namuno District',	'Nangade District'	,'Palma District'	,'Pemba-Metuge District'	,'Quissanga District'].sort(),
      'GH': ['Yendi', 'Mion', 'Karaga',	'Gushegu',	'Nanton','Sagnarigu',	'East Mamprusi',	'Mamprugu',	'Moagduri',	'Bawku Municipal','Bawku West',	'Garu Tempane','Daffiama Bussie Issa', 'Nadowli-Kaleo', 'Sissala East', 'Sissala West','Wa East'].sort() 
    };

    const theOther = {
      'MZ': 'Outside Cabo Delgado',
      'GH': 'Other districts of Ghana'
    };

    if (dists[userCountry]) {
      $('#districts_list').show();
      const theList = dists[userCountry];
      theList.push(theOther[userCountry])
      $('#districts').html(theList.map(dist => `<option value="${dist}">`));
    } else {
      $('#districts_list').hide();
      $('#districts').html(null);
    }


    const code = userCountry ? userCountry.toLowerCase() : null;
    if (code && code !== 'Select your country') {
      $('#user_phone').intlTelInput('setCountry', userCountry.toLowerCase());
      $.getJSON('/get_language_for_country?country_code=' + code, (response) => {
        if (response.lang && availableLangs.indexOf(response.lang) !== -1) {
          $('#user_lang').val(response.lang);
        } else {
          $('#user_lang').val('');
        }
      });
    }
  });

  $('form').submit(() => {
    const password = $('#user_password').val();
    const password_confirm = $('#user_password_confirmation').val();
    $('#user_email').val($('#user_email').val().trim());


    if ($('#districts_list:visible').length && !$('#districts_list').first().val()) {
      alert('You must enter the home district where you live.');
      return false;
    }

    if (password.length < 6) {
      alert('Your password must be at least six characters.');
      return false;
    }
    else if (password !== password_confirm) {
      alert('Your password and password confirmation do not match.');
      return false;
    }
    else if (!validateEmail($('#user_email').val())) {
      alert('You must enter a valid email address.');
      return false;
    }
    else if ($('#user_phone').val() === '' || $('#user_country').val().length === 0) {
      alert('You must enter a phone number');
      return false;
    }
    else if ($('.user_state select:visible').length === 1 && $('.user_state select:visible').val() === '') {
      alert('You must choose a state/region for your country.');
      return false;
    } else if (!$('#tos_check').prop('checked')) {
      alert("<%= t('views.ondemand.must_agree_to_collector_terms') %>");
    }
    else {
      if (window.fbq) {
        fbq('track', 'SubmitApplication');
      }

      if (window.gtag_report_conversion) {
        gtag_report_conversion();
      }
      return true;
    }
  });

  const getLocFromGeo = function () {
    $.ajax({
      url: 'https://get.geojs.io/v1/ip/geo.js',
      dataType: 'jsonp',
      success: function (response) {
        $('#user_country').val(response.country_code);
        $('#user_country').change();
        $('#user_city').show();
        $('#user_city').val(response.city);
        $('#user_state').val(response.region);
        $('#user_latitude').val(response.latitude);
        $('#user_longitude').val(response.longitude);
      }
    });
  };
  
  getLocFromGeo();
});
